import {
  Component,
  OnChanges,
  SimpleChange,
  OnInit,
  Inject,
  Injector,
  AfterContentInit,
  ContentChildren,
  ViewChild,
  QueryList,
  Optional,
  forwardRef,
  ElementRef,
  NgModule,
  ViewEncapsulation,
  EventEmitter
} from '@angular/core';
import { RouterModule } from '@angular/router';
import { ObservableWrapper } from '../../util/async';

import { MdCheckbox } from '@angular/material';
import { OSharedModule } from '../../shared';
import { CommonModule } from '@angular/common';
import { OntimizeService } from '../../services';
import { dataServiceFactory } from '../../services/data-service.provider';
import { OSearchInputModule, OSearchInputComponent } from '../search-input/o-search-input.component';
import { OListItemModule } from './list-item/o-list-item.component';
import { OFormComponent } from '../form/o-form.component';
import { InputConverter } from '../../decorators';
import { Util } from '../../util/util';
import { OListItemComponent } from './list-item/o-list-item.component';
import { OListItemDirective } from './list-item/o-list-item.directive';

import { OServiceComponent } from '../o-service-component.class';
import { Observable } from 'rxjs/Observable';

export interface IList {
  registerListItemDirective(item: OListItemDirective): void;
  getKeys(): Array<string>;
  setSelected(item: Object);
  isItemSelected(item: Object);
}

export const DEFAULT_INPUTS_O_LIST = [
  ...OServiceComponent.DEFAULT_INPUTS_O_SERVICE_COMPONENT,

  // quick-filter [no|yes]: show quick filter. Default: yes.
  'quickFilter: quick-filter',

  // quick-filter-columns [string]: columns of the filter, separated by ';'. Default: no value.
  'quickFilterColumns: quick-filter-columns',

  // refresh-button [no|yes]: show refresh button. Default: yes.
  'refreshButton: refresh-button',

  'route',

  'selectable',

  'odense : dense'
];

export const DEFAULT_OUTPUTS_O_LIST = [
  'onChange'
];

export interface OListInitializationOptions {
  entity?: string;
  service?: string;
  columns?: string;
  quickFilterColumns?: string;
  keys?: string;
  parentKeys?: string;
}


export class OListComponent extends OServiceComponent implements OnInit, IList, AfterContentInit, OnChanges {

  public static DEFAULT_INPUTS_O_LIST = DEFAULT_INPUTS_O_LIST;
  public static DEFAULT_OUTPUTS_O_LIST = DEFAULT_OUTPUTS_O_LIST;

  /* Inputs */
  @InputConverter()
  quickFilter: boolean = true;
  protected quickFilterColumns: string;
  @InputConverter()
  refreshButton: boolean = true;
  protected route: string;
  @InputConverter()
  selectable: boolean = false;
  @InputConverter()
  odense: boolean = false;
  /* End Inputs */

  
  listItemComponents: QueryList<OListItemComponent>;

  
  listItemDirectives: QueryList<OListItemDirective>;

  
  searchInputComponent: OSearchInputComponent;

  public mdClick: EventEmitter<any> = new EventEmitter();
  public mdDblClick: EventEmitter<any> = new EventEmitter();

  public onListDataLoaded: EventEmitter<any> = new EventEmitter();
  public onPaginatedListDataLoaded: EventEmitter<any> = new EventEmitter();
  protected quickFilterColArray: string[];

  protected dataResponseArray: Array<any> = [];

  constructor(
    injector: Injector,
    elRef: ElementRef,
      form: OFormComponent
  ) {
    super(injector, elRef, form);
  }

  getComponentKey(): string {
    return 'OListComponent_' + this.oattr;
  }

  registerSearchInput(input: OSearchInputComponent) {
    if (input && this.quickFilter) {
      var self = this;
      input.onSearch.subscribe(val => {
        self.filterData(val);
      });
    }
  }

  public onListItemClicked(onNext: (item: OListItemDirective) => void): Object {
    return ObservableWrapper.subscribe(this.mdClick, onNext);
  }

  ngOnInit(): void {
    this.initialize();
  }

  public ngOnChanges(changes: { [propName: string]: SimpleChange }) {
    if (typeof (changes['staticData']) !== 'undefined') {
      this.dataResponseArray = changes['staticData'].currentValue;
      let filter = (this.state && this.state.filterValue) ? this.state.filterValue : undefined;
      this.filterData(filter);
    }
  }

  reinitialize(options: OListInitializationOptions) {
    super.reinitialize(options);
  }

  initialize(): void {
    super.initialize();

    if (this.staticData && this.staticData.length) {
      this.dataResponseArray = this.staticData;
    }

    if (this.quickFilterColumns) {
      this.quickFilterColArray = Util.parseArray(this.quickFilterColumns);
    } else {
      this.quickFilterColArray = this.colArray;
    }

    this.state = this.localStorageService.getComponentStorage(this);
    let initialQueryLength = undefined;
    if (this.state.hasOwnProperty('queryRecordOffset')) {
      initialQueryLength = this.state.queryRecordOffset;
    }
    this.state.queryRecordOffset = 0;
    if (!this.state.hasOwnProperty('queryTotalRecordNumber')) {
      this.state.queryTotalRecordNumber = 0;
    }
    if (this.queryOnInit) {
      let queryArgs = {
        offset: 0,
        length: initialQueryLength || this.queryRows
      };
      this.queryData({}, queryArgs);
    }
  }

  ngOnDestroy() {
    this.destroy();
  }

  destroy() {
    super.destroy();
    this.onRouteChangeStorageSubscribe.unsubscribe();
  }

  ngAfterViewInit() {
    if (this.searchInputComponent) {
      this.registerSearchInput(this.searchInputComponent);
    }
  }

  getDense() {
    return this.odense || undefined;
  }

  protected setListItemsData() {
    var self = this;
    this.listItemComponents.forEach(function (element: OListItemComponent, index) {
      element.setItemData(self.dataResponseArray[index]);
    });
  }

  protected setListItemDirectivesData() {
    var self = this;
    this.listItemDirectives.forEach(function (element: OListItemDirective, index) {
      element.setItemData(self.dataResponseArray[index]);
      element.setListComponent(self);
      self.registerListItemDirective(element);
    });
  }

  ngAfterContentInit() {
    var self = this;
    self.setListItemsData();
    this.listItemComponents.changes.subscribe(() => {
      self.setListItemsData();
    });
    self.setListItemDirectivesData();
    this.listItemDirectives.changes.subscribe(() => {
      self.setListItemDirectivesData();
    });
  }

  registerListItemDirective(item: OListItemDirective) {
    if (item) {
      var self = this;
      if (this.detailMode === OServiceComponent.DETAIL_MODE_CLICK) {
        item.onClick(directiveItem => {
          self.onItemDetailClick(directiveItem);
        });
      }
      if (this.detailMode === OServiceComponent.DETAIL_MODE_DBLCLICK) {
        item.onDblClick(directiveItem => {
          self.onItemDetailDblClick(directiveItem);
        });
      }
    }
  }

  onItemDetailClick(item: OListItemDirective | OListItemComponent) {
    if (this.oenabled && this.detailMode === OServiceComponent.DETAIL_MODE_CLICK) {
      this.viewDetail(item.getItemData());
      ObservableWrapper.callEmit(this.mdClick, item);
    }
  }

  onItemDetailDblClick(item: OListItemDirective | OListItemComponent) {
    if (this.oenabled && this.detailMode === OServiceComponent.DETAIL_MODE_DBLCLICK) {
      this.viewDetail(item.getItemData());
      ObservableWrapper.callEmit(this.mdDblClick, item);
    }
  }

  queryData(filter: Object = {}, ovrrArgs?: any) {
    if (this.querySuscription) {
      this.querySuscription.unsubscribe();
      this.loaderSuscription.unsubscribe();
    }
    let queryMethodName = this.pageable ? this.paginatedQueryMethod : this.queryMethod;
    if (this.dataService && (queryMethodName in this.dataService) && this.entity) {

      this.setParentKeyValues(filter);

      this.loaderSuscription = this.load();

      let queryArguments = this.getQueryArguments(filter, ovrrArgs);
      var self = this;
      this.querySuscription = this.dataService[queryMethodName].apply(this.dataService, queryArguments)
        .subscribe(res => {
          let data = undefined;
          if (Util.isArray(res)) {
            data = res;
          } else if ((res.code === 0) && Util.isArray(res.data)) {
            data = res.data;
            if (this.pageable) {
              this.updatePaginationInfo(res);
            }
          }
          // set list data
          if (Util.isArray(data)) {
            let respDataArray = data;
            if (self.pageable && !(ovrrArgs && ovrrArgs['replace'])) {
              respDataArray = (self.dataResponseArray || []).concat(data);
            }

            let selectedIndexes = self.state.selectedIndexes || [];
            for (let i = 0; i < selectedIndexes.length; i++) {
              if (selectedIndexes[i] < self.dataResponseArray.length) {
                self.selectedItems.push(self.dataResponseArray[selectedIndexes[i]]);
              }
            }
            self.dataResponseArray = respDataArray;
            self.filterData(self.state.filterValue);
          } else {
            self.setDataArray([]);
          }

          self.loaderSuscription.unsubscribe();
          if (self.pageable) {
            ObservableWrapper.callEmit(self.onPaginatedListDataLoaded, data);
          }
          ObservableWrapper.callEmit(self.onListDataLoaded, self.dataResponseArray);
        }, err => {
          console.log('[OList.queryData]: error', err);
          self.setDataArray([]);
          self.loaderSuscription.unsubscribe();
        });
    }
  }

  setParentKeyValues(filter: Object) {
    if (this._pKeysEquiv && this.parentItem) {
      for (let key in this._pKeysEquiv) {
        if (this.parentItem.hasOwnProperty(key)) {
          filter[this._pKeysEquiv[key]] = this.parentItem[key];
        }
      }
    }
  }

  /**
   *@deprecated
   */
  onReload() {
    this.reloadData();
  }

  reloadData() {
    let queryArgs = {};
    if (this.pageable) {
      this.state.queryRecordOffset = 0;
      queryArgs = {
        length: this.dataResponseArray.length,
        replace: true
      };
    }
    if (this.selectable) {
      this.selectedItems = [];
      this.state.selectedIndexes = [];
    }
    this.queryData(this.parentItem, queryArgs);
  }

  configureFilterValue(value: string) {
    let returnVal = value;
    if (value && value.length > 0) {
      if (!value.startsWith('*')) {
        returnVal = '*' + returnVal;
      }
      if (!value.endsWith('*')) {
        returnVal = returnVal + '*';
      }

      returnVal = returnVal.replace(new RegExp('[a\u00E1A\u00C1]', 'gi'), '[a\u00E1A\u00C1]');
      returnVal = returnVal.replace(new RegExp('[e\u00E9E\u00C9]', 'gi'), '[e\u00E9E\u00C9]');
      returnVal = returnVal.replace(new RegExp('[i\u00EDI\u00CD]', 'gi'), '[i\u00EDI\u00CD]');
      returnVal = returnVal.replace(new RegExp('[o\u00F3O\u00D3]', 'gi'), '[o\u00F3O\u00D3]');
      returnVal = returnVal.replace(new RegExp('[u\u00FAU\u00DA]', 'gi'), '[u\u00FAU\u00DA]');
      //ñÑ
      returnVal = returnVal.replace(new RegExp('[\u00F1\u00D1]', 'gi'), '[\u00F1\u00D1]');

      returnVal = returnVal.replace(new RegExp('\\*', 'gi'), '.*');
      returnVal = returnVal.replace(new RegExp('\\+', 'gi'), '\\\\+');
      returnVal = returnVal.replace(new RegExp('\\?', 'gi'), '\\\\?');
      returnVal = returnVal.replace(new RegExp('\\(', 'gi'), '\\\\(');
      returnVal = returnVal.replace(new RegExp('\\)', 'gi'), '\\\\)');
    }

    return returnVal;
  }
  /**
   * Improve this method.
   * Filters data locally.
   *  */
  filterData(value: string): void {
    if (this.state) {
      this.state.filterValue = value;
    }
    if (value && value.length > 0 && this.dataResponseArray && this.dataResponseArray.length > 0) {
      var _val = this.configureFilterValue(value);
      var self = this;
      var filteredData = this.dataResponseArray.filter(item => {
        let found = false;
        let regExp: RegExp = new RegExp(_val, 'i');
        self.quickFilterColArray.forEach(col => {
          let current = item[col];
          if (current) {
            if (typeof current === 'string') {
              let match = regExp.exec(current.toLowerCase());
              if (match && match.length > 0) {
                found = true;
              }
            }
          }
        });
        return found;
      });
      this.setDataArray(filteredData);
    } else {
      this.setDataArray(this.dataResponseArray);
    }
  }

  isItemSelected(item) {
    let result = this.selectedItems.find(current => {
      let itemKeys = Object.keys(item);
      let currentKeys = Object.keys(current);
      if (itemKeys.length !== currentKeys.length) {
        return false;
      }
      let found = true;
      itemKeys.forEach(key => {
        if (current.hasOwnProperty(key)) {
          if (current[key] !== item[key]) {
            found = false;
          }
        } else {
          found = false;
        }
      });
      return found;
    });
    if (result) {
      return true;
    } else {
      return false;
    }
  }

  setSelected(item) {
    if (this.selectable) {
      let idx = this.selectedItems.indexOf(item);
      let wasSelected = idx > -1;
      if (wasSelected) {
        this.selectedItems.splice(idx, 1);
      } else {
        this.selectedItems.push(item);
      }
      this.updateSelectedState(item, !wasSelected);
      return !wasSelected;
    }
    return undefined;
  }

  updateSelectedState(item: Object, isSelected: boolean) {
    let selectedIndexes = this.state.selectedIndexes || [];
    let itemIndex = this.dataResponseArray.indexOf(item);
    if (isSelected && selectedIndexes.indexOf(itemIndex) === -1) {
      selectedIndexes.push(itemIndex);
    } else if (!isSelected) {
      selectedIndexes.splice(selectedIndexes.indexOf(itemIndex), 1);
    }
    this.state.selectedIndexes = selectedIndexes;
  }

  onScroll($event: Event): void {
    let pendingRegistries = this.dataResponseArray.length < this.state.queryTotalRecordNumber;
    if (!this.loading && pendingRegistries) {
      let element = $event.srcElement as any;
      if (element.offsetHeight + element.scrollTop + 5 >= element.scrollHeight) {
        let queryArgs = {
          offset: this.state.queryRecordOffset,
          length: this.queryRows
        };
        this.queryData({}, queryArgs);
      }
    }
  }

  remove(clearSelectedItems: boolean = false) {
    this.dialogService.confirm('CONFIRM', 'MESSAGES.CONFIRM_DELETE').then(
      res => {
        if (res === true) {
          if (this.dataService && (this.deleteMethod in this.dataService) && this.entity && (this.keysArray.length > 0)) {
            let filters = [];
            this.selectedItems.map(item => {
              let kv = {};
              for (let k = 0; k < this.keysArray.length; ++k) {
                let key = this.keysArray[k];
                kv[key] = item[key];
              }
              filters.push(kv);
            });

            let observable = (Observable as any).from(filters)
              .map(kv => this.dataService[this.deleteMethod](kv, this.entity)).mergeAll();
            observable.subscribe(
              res => {
                console.log('[OList.remove]: response', res);
              },
              error => {
                this.dialogService.alert('ERROR', 'MESSAGES.ERROR_DELETE');
                console.log('[OList.remove]: error', error);
              },
              () => {
                this.queryData(this.parentItem);
              }
            );
          } else {
            this.deleteLocalItems();
          }
        } else if (clearSelectedItems) {
          this.selectedItems = [];
        }
      });
  }

  protected add() {
    let route = this.getRouteOfSelectedRow(undefined, 'new');
    if (route.length > 0) {
      this.router.navigate(route,
        {
          relativeTo: this.actRoute,
        }
      );
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'o-list',
  providers: [
    { provide: OntimizeService, useFactory: dataServiceFactory, deps: [Injector] }
  ],
  inputs: [
    ...DEFAULT_INPUTS_O_LIST
  ],
  outputs: [
    ...DEFAULT_OUTPUTS_O_LIST
  ],
  template: `
    <div class="o-list-container" fxFill>
      <div *ngIf="loading" [class.pageable-loading]="pageable && state.queryRecordOffset > 0" class="spinner-container" fxFlex="100"
        fxLayout="row" fxLayoutAlign="center center">
        <md-progress-spinner *ngIf="loading" mode="indeterminate">
        </md-progress-spinner>
      </div>

      <md-toolbar class="toolbar-filter-list" [class.dense]="odense" *ngIf="hasControls()">
        <div class="mat-toolbar-tools" fxLayout="row" fxFill fxLayoutAlign="start center">
          <button type="button" md-icon-button aria-label="Refresh" (click)="reloadData()" *ngIf="refreshButton">
            <md-icon>autorenew</md-icon>
          </button>
          <button type="button" md-icon-button aria-label="Delete" (click)="remove()" *ngIf="selectedItems.length">
            <md-icon>delete</md-icon>
          </button>
          <span class="fill-remaining"></span>
          <div *ngIf="title" fxLayout="row" fxLayoutAlign="center center">
            <span>{{  title | oTranslate }}</span>
          </div>
          <span *ngIf="title" class="fill-remaining"></span>

          <o-search-input *ngIf="quickFilter" placeholder=""></o-search-input>
        </div>
      </md-toolbar>

      <div fxLayout="column" class="fill-remaining">
        <md-list class="mat-list" [attr.dense]="odense || undefined" [class.selectable]="selectable" (scroll)="onScroll($event)"
          [class.o-list-1-detail-buttons]="(editButtonInRow || detailButtonInRow) && !(editButtonInRow && detailButtonInRow)" [class.o-list-2-detail-buttons]="editButtonInRow && detailButtonInRow">
          <md-list-item *ngIf="!getDataArray().length" fxLayout="row" fxLayoutAlign="center center" style="cursor: default;">
            <h3 mdLine>{{ 'TABLE.EMPTY' | oTranslate }}</h3>
          </md-list-item>
          <ng-content></ng-content>
        </md-list>
        <button *ngIf="insertButton && odense" md-mini-fab (click)="add()" class="add-button">
          <md-icon>add</md-icon>
        </button>
        <button *ngIf="insertButton && !odense" md-fab (click)="add()" class="add-button">
          <md-icon>add</md-icon>
        </button>
      </div>
    </div>
  `,
  styles: [`
    ::-webkit-input-placeholder{color:#8E0C39}:-moz-placeholder{color:#8E0C39;opacity:1}::-moz-placeholder{color:#8E0C39;opacity:1}:-ms-input-placeholder{color:#8E0C39}:placeholder-shown{color:#8E0C39}.o-list-container{position:relative;display:flex;flex-direction:column}.o-list-container md-toolbar.dense{min-height:48px}.o-list-container md-toolbar.dense md-toolbar-row{height:48px}.o-list-container .o-search{position:relative;height:30px}.o-list-container .o-search>.mat-icon{position:absolute;top:0.15em;left:0.3em;color:#8E0C39}.o-list-container .o-search-input{height:25px;width:80%;font-size:15px;border:1px solid #8E0C39;border-radius:20px;padding-left:30px}.o-list-container .o-list-title{font-size:1.5em}.o-list-container .spinner-container{position:absolute;left:0px;right:0px;bottom:0px;z-index:500}.o-list-container .spinner-container:not(.pageable-loading){top:0px;background:#fff}.o-list-container .spinner-container.pageable-loading{background:rgba(255,255,255,0.5)}.o-list-container .spinner-container path{stroke-width:5px !important}.o-list-container .fill-remaining{flex:1 1 auto}.o-list-container .mat-list{overflow:auto}.o-list-container .mat-list .mat-3-line .o-custom-list-item{position:relative}.o-list-container .mat-list .o-custom-list-item{max-width:100%;width:100%}.o-list-container .mat-list .o-custom-list-item .o-list-item-icon{cursor:pointer}.o-list-container .mat-list .o-custom-list-item .o-list-item-icon.top{position:absolute;top:0;right:0}.o-list-container .mat-list.o-list-1-detail-buttons md-list-item,.o-list-container .mat-list.o-list-2-detail-buttons md-list-item{-moz-box-sizing:border-box;-webkit-box-sizing:border-box;box-sizing:border-box}.o-list-container .mat-list.o-list-1-detail-buttons md-list-item .mat-list-item,.o-list-container .mat-list.o-list-2-detail-buttons md-list-item .mat-list-item{padding-right:0px}.o-list-container .mat-list:not(.selectable).o-list-1-detail-buttons .mat-list-item-content{padding-right:40px}.o-list-container .mat-list:not(.selectable).o-list-2-detail-buttons .mat-list-item-content{padding-right:64px}.o-list-container .mat-list:not(.selectable):not(.o-list-1-detail-buttons):not(.o-list-2-detail-buttons) .mat-list-text{padding-right:0px}.o-list-container .mat-list.selectable.o-list-1-detail-buttons .mat-list-item-content{padding-right:60px}.o-list-container .mat-list.selectable[dense].o-list-1-detail-buttons .mat-list-item-content{padding-right:56px}.o-list-container .mat-list.selectable.o-list-2-detail-buttons .mat-list-item-content{padding-right:84px}.o-list-container .mat-list.selectable[dense].o-list-2-detail-buttons .mat-list-item-content{padding-right:80px}.o-list-container .add-button{right:16px;bottom:16px;position:absolute}
  `],
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: Injector, },
{type: ElementRef, },
{type: OFormComponent, decorators: [{ type: Optional }, { type: Inject, args: [forwardRef(() => OFormComponent), ] }, ]},
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'listItemComponents': [{ type: ContentChildren, args: [OListItemComponent, ] },],
'listItemDirectives': [{ type: ContentChildren, args: [OListItemDirective, ] },],
'searchInputComponent': [{ type: ViewChild, args: [OSearchInputComponent, ] },],
};
}


export class OListModule {
static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  declarations: [OListComponent],
  imports: [OSharedModule, CommonModule, OListItemModule, OSearchInputModule, RouterModule],
  exports: [OListComponent],
  entryComponents: [MdCheckbox]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
